import {
  PersonalizedProductDetailsResponse,
  ProductPriceObj,
} from 'api/product/getPersonalizedProductDetails/types';
import cn from 'classnames';
import { OrderType } from 'constants/order';
import { FormattedMessage } from 'react-intl';
import DiscountCouponIcon from './discount-coupon.svg';

type Props = {
  couponPrices: ProductPriceObj;
  discountedPrice: PersonalizedProductDetailsResponse['variants'][number];
  orderType: OrderType;
} & React.DetailedHTMLProps<
  React.HTMLAttributes<HTMLDivElement>,
  HTMLDivElement
>;

/**
 * Display information of coupon, percentage and MOV
 * If special discount is applied on backend and then it wouldn't be shown
 */
const CouponDisplay: React.FC<Props> = ({
  couponPrices,
  discountedPrice,
  className,
  orderType,
  ...others
}) => {
  const couponName = couponPrices.coupon?.code;
  const discountPercentage = couponPrices.coupon?.percentage;
  const minimumBasketValue = couponPrices.coupon?.minimumBasketValue;
  const hasCouponDiscount =
    discountPercentage && couponName && !!discountedPrice;

  // Do not show coupon if it doesn't apply to the current order type
  if (
    (orderType === OrderType.SUBSCRIPTION &&
      !couponPrices.coupon?.appliesToSubscriptions) ||
    (orderType === OrderType.ONE_OFF && !couponPrices.coupon?.appliesToOneOff)
  ) {
    return null;
  }

  return (
    <>
      {hasCouponDiscount && (
        <div
          className={cn(
            'mt-4 flex h-11 items-center gap-1.5 rounded-sm bg-turquoise-50 p-1.5 text-sm text-green-900',
            className
          )}
          {...others}
        >
          <DiscountCouponIcon className="h-4 w-4 shrink-0" />
          <div>
            <span className="block text-sm leading-4">
              <FormattedMessage
                id="pdp:buy-panel:coupon-price-personalization:discount-percentage"
                values={{
                  discount: discountPercentage * 100,
                  couponName: couponName,
                }}
              />
            </span>
            {minimumBasketValue && (
              <span className="block text-xs leading-3">
                <FormattedMessage
                  id="pdp:buy-panel:coupon-price-personalization:mov-info"
                  values={{
                    mov: minimumBasketValue,
                  }}
                />
              </span>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default CouponDisplay;
